import {
  DynamicWidgetProps,
  ProductListWidgetType,
  StorefrontWidget,
  WidgetRelatedProducts,
  WidgetTagProducts
} from 'ecosystem'
import { storefrontWidgetRegistry } from 'storefront-modules/widgets/registry/StorefrontWidgetRegistry'
import CustomContact from '#/src/custom/components/CustomContact'
import { CategoryToolbarWidgetType } from 'storefront-modules/categories/widgets/CategoryToolbarWidget'
import CustomCategoryToolbarWidget from '#/src/custom/widgets/CustomCategoryToolbarWidget'
import CustomProductListWidget from './CustomProductListWidget'
import CustomCategoryTreeWidget from '#/src/custom/widgets/CustomCategoryTreeWidget'
import { CustomRelatedProductsWidget } from '#/src/custom/widgets/CustomRelatedProductsWidget'
import { CustomTagProductsWidget } from '#/src/custom/widgets/CustomTagProductsWidget'

// declare here the widget extensions names. No need to re declare the overriden shared widgets
type WidgetsExtension = 'CONTACT_FORM'

export const widgetsConfig = (
  widget: StorefrontWidget,
  // These can be used to create dynamic widgets
  dynamicProps?: DynamicWidgetProps
) => {
  return storefrontWidgetRegistry<WidgetsExtension>(widget, {
    dynamicProps,
    extensions: {
      CONTACT_FORM: <CustomContact withDropZone />,

      CATEGORY_TREE: (
        <CustomCategoryTreeWidget
          widget={widget as StorefrontWidget<CategoryToolbarWidgetType>}
          {...{ dynamicProps }}
        />
      ),

      CATEGORY_TOOLBAR: (
        <CustomCategoryToolbarWidget
          widget={widget as StorefrontWidget<CategoryToolbarWidgetType>}
          {...{ dynamicProps }}
        />
      ),

      PRODUCT_LIST: (
        <CustomProductListWidget
          type="PRODUCT_LIST"
          widget={widget as StorefrontWidget<ProductListWidgetType>}
          {...{ dynamicProps }}
        />
      ),

      PRODUCT_LIST_1: (
        <CustomProductListWidget
          type="PRODUCT_LIST_1"
          widget={widget as StorefrontWidget<ProductListWidgetType>}
          {...{ dynamicProps }}
        />
      ),

      WIDGET_RELATED_PRODUCTS: (
        <CustomRelatedProductsWidget widget={widget as StorefrontWidget<WidgetRelatedProducts>} />
      ),

      WIDGET_TAG_PRODUCTS: (
        <CustomTagProductsWidget widget={widget as StorefrontWidget<WidgetTagProducts>} />
      )
    }
  })
}
